import { message, Modal } from 'hljd'
import { isPhone } from '@hlj/hlj-utils'
import { Api } from '../util'
import { observable, action, runInAction } from 'mobx'
import { hashHistory } from 'react-router'
import { getChartLength } from '@util'

export default class Store {
  //表单字段
  @observable name = ''
  @observable phone = ''
  @observable contact_mobile = ''

  @observable shop_area = []
  @observable des = ''
  @observable logo_path_square = ''
  @observable working_at = null
  @observable position = null

  @observable shop_area_save = []
  @observable loading = false

  //获取数据
  @action
  changeField = type => (value, selectedOptions) => {
    if (type === 'contact_mobile' || type === 'phone') {
      this[type] = value.replace(/[^0-9]+/, '')
    } else {
      this[type] = value

      if (type == 'shop_area') {
        this.shop_area_save = selectedOptions
      }
    }
  }
  @observable country = []

  getCountry = async () => {
    const { data } = await Api.getPCCApi({ hide_city: 1 })
    this.country = data || []
  }

  //上传图片
  @action
  upload = type => (file, src) => {
    this[type] = src
  }
  //删除图片
  @action
  removeImg = type => () => {
    this[type] = ''
  }
  @action
  clipPic = type => ({ clipUrl }) => {
    this[type] = clipUrl
  }

  //获取类型
  @observable storeType = []
  @action
  async getStoreType() {
    let { data = [], success } = await Api.getStoreTypeApi({ show_hotel: 1 })
    runInAction(() => {
      if (success) {
        this.storeType = data
      }
    })
  }

  validation = () => {
    const {
      logo_path_square,
      name,
      working_at,
      position,
      shop_area,
      contact_mobile,
      phone,
      des
    } = this
    if (phone.trim() === '') {
      return '请输入联系电话'
    }

    if (!isPhone(phone)) {
      return '请输入正确的手机号码'
    }
    if (logo_path_square == '') {
      return '请上传头像'
    }

    if (name.trim() === '') {
      return '请输入称呼'
    }

    if (getChartLength(name.trim(), 'ceil') > 4) {
      return '称呼不能超过4个字符'
    }

    if (!working_at) {
      return '请选择入行时间'
    }

    if (!position) {
      return '请选择职位'
    }

    if (shop_area.length == 0) {
      return '请选择所在地区'
    }

    if (contact_mobile.trim() === '') {
      return '请输入联系电话'
    }

    if (!isPhone(contact_mobile)) {
      return '请输入正确的手机号码'
    }

    if (des.trim() !== '' && des.trim().length > 100) {
      return '个人简介不能超过100个字'
    }

    return 'pass'
  }

  getFormData = () => {
    const msg = this.validation()

    if (msg == 'pass') {
      const {
        name,
        contact_mobile,
        phone,
        shop_area,
        des,
        logo_path_square,
        working_at,
        position
      } = this

      return {
        name,
        phone,
        contact_mobile,
        shop_area_id: shop_area[2],
        des: !des ? null : des,
        logo_path_square,
        working_at,
        position
      }
    } else {
      message.warning(msg, 2)
      return false
    }
  }

  updateStoreInfo = async () => {
    let params = this.getFormData()

    if (params && !this.loading) {
      this.loading = true
      const { success } = await Api.createGroupMember(params)
      this.loading = false
      if (success) {
        Modal.info({
          title: '创建成员信息成功',
          content: '请通知成员根据短信链接提示提交认证材料',
          okText: '知道了',
          onOk: () => {
            hashHistory.push('/localMerchant/groupMember')
          }
        })
      }
    }
  }
}
